/**
 * Quantity Discount Widget
 * Wires the tier selector to the product form:
 * 1. Updates the quantity input when a tier is selected
 * 2. Activates the correct discount code via /discount/[code] before submitting
 * 3. Handles the add-to-cart with the correct quantity
 */

(function () {
  function initQuantityDiscount(widget) {
    const sectionId = widget.dataset.sectionId;
    const tiers = widget.querySelectorAll('.qty-tier');
    const qtyInput = document.getElementById(`product-qty-section`);
    const discountInput = document.getElementById(`product-discount-section`);
    const form = document.getElementById(`product-form-section`);

    if (!qtyInput || !form) return;

    // Select a tier: update quantity + discount code
    function selectTier(tierEl) {
      tiers.forEach(t => t.classList.remove('qty-tier--active'));
      tierEl.classList.add('qty-tier--active');

      const qty = tierEl.dataset.qty || 1;
      const code = tierEl.dataset.code || '';

      if (qtyInput) qtyInput.value = qty;
      if (discountInput) discountInput.value = code;

      // Also update any other quantity inputs in the form just in case
      form.querySelectorAll('input[name="quantity"]').forEach(input => {
        input.value = qty;
      });
    }

    // Bind click on entire label
    tiers.forEach(tier => {
      tier.addEventListener('click', () => selectTier(tier));
    });

    // Handle Buy Now button specifically
    const buyNowBtn = form.querySelector('[data-buy-now]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        const qty = qtyInput ? qtyInput.value : 1;
        const code = discountInput ? discountInput.value.trim() : '';
        const variantId = form.querySelector('[name="id"]').value;

        // Visual feedback
        const originalText = buyNowBtn.textContent;
        buyNowBtn.textContent = 'Processing...';
        buyNowBtn.disabled = true;

        try {
          // 1. Activate discount if present
          if (code) {
            await fetch(`/discount/${encodeURIComponent(code)}`);
          }

          // 2. Add to cart via AJAX
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: parseInt(qty) }]
            })
          });

          if (response.ok) {
            // 3. Redirect to checkout
            window.location.href = '/checkout';
          } else {
            const err = await response.json();
            alert('Error: ' + (err.description || err.message));
            buyNowBtn.textContent = originalText;
            buyNowBtn.disabled = false;
          }
        } catch (err) {
          console.error('Buy Now failed:', err);
          window.location.href = '/checkout'; // Fallback attempt
        }
      }, true); 
    }

    // Intercept form submit (for Add to Cart)
    form.addEventListener('submit', async function (e) {
      const code = discountInput ? discountInput.value.trim() : '';

      if (code) {
        e.preventDefault();

        try {
          // Activate the discount code on the cart
          await fetch(`/discount/${encodeURIComponent(code)}`, {
            method: 'GET',
            credentials: 'same-origin',
          });
        } catch (_) {
          // Silently continue — discount may already be active or network issue
        }

        // Now submit the form normally (adds item to cart with correct quantity)
        form.removeEventListener('submit', arguments.callee);
        form.submit();
      }
      // If no code (tier 1), let form submit naturally
    });
  }

  // Init on DOMContentLoaded
  function init() {
    document.querySelectorAll('.qty-discount-widget').forEach(initQuantityDiscount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
